import React, { FC } from 'react';
import { searchConstants } from '../../../../search-utils/searchConstants';
import { DatesSelectors } from './DatesSelectors';
import { CommonSection } from '../../CommonSection';

type Props = {
  search_type: 'decision' | 'commentary' | 'law' | 'lawyer' | 'enterprise';
};

export const Dates: FC<Props> = ({ search_type }) => {
  return (
    <CommonSection title={searchConstants.filters.dates}>
      <DatesSelectors type={search_type} />
    </CommonSection>
  );
};
